export default __webpack_public_path__ + "static/media/MedicationNotTaken.0959e333.svg";